import { MySelector } from "../../redux/store"
import { useBrandLogo } from "../../hooks/useBrandLogo"

/**
 * Full-page loading screen shown while event data / photos are being fetched.
 * A plain themed background with an indeterminate linear progress bar.
 *
 * Once the event has loaded we know the brand, so we show the centered logo
 * (photographer's for whitelabel accounts, otherwise It's Forever) above a gold
 * bar. During a cold load the brand is still unknown, so we stay brand-neutral:
 * no logo and a neutral bar, so a whitelabel client never flashes the IFE logo.
 */
const FullScreenLoader = () => {
  const { theme } = MySelector((state) => state.theme)
  const brandLogo = useBrandLogo()

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-7 bg-white dark:bg-black">
      {brandLogo.brandKnown && (
        <img
          src={theme === "dark" ? brandLogo.dark : brandLogo.light}
          alt="logo"
          className={`w-[170px] md:w-[210px] h-auto ${brandLogo.shadowClass}`}
        />
      )}
      <div className="relative h-[3px] w-[150px] md:w-[190px] overflow-hidden rounded-full bg-black/10 dark:bg-white/15">
        <div
          className={`absolute inset-y-0 left-0 w-1/3 rounded-full animate-loaderBar ${
            brandLogo.brandKnown ? "goldbg" : "bg-black/40 dark:bg-white/40"
          }`}
        />
      </div>
    </div>
  )
}

export default FullScreenLoader
